/**
 * Reads page input modality, defaulting to `mouse` when none has been recorded.
 *
 * Mount `AetherProvider` to enable tracking. Its internal input tracker owns
 * `body[data-modality]`; this public API exposes only the shared type and a snapshot.
 */
export function getInputModality() {
    const modality = document.body.dataset.modality;
    if (modality === 'keyboard') {
        return 'keyboard';
    }
    return 'mouse';
}
//# sourceMappingURL=getInputModality.js.map